import { createContext } from 'react';

import { MainLayoutState } from './types';

export const MainLayoutContext = createContext<MainLayoutState>({
  isInsideMainLayout: false,
} as never);
